import React from "react";

export default function WExpirateIcon({ color = "currentColor" }) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      style={{ color }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.88889 26C2.09444 26 1.41459 25.7174 0.849333 25.1521C0.284074 24.5869 0.000962963 23.9065 0 23.1111V5.09167C0 4.75464 0.0544073 4.42964 0.163222 4.11667C0.272037 3.80371 0.434296 3.51482 0.65 3.25001L2.45555 1.04723C2.72037 0.710193 3.05115 0.451156 3.44789 0.270119C3.84463 0.0890817 4.26015 -0.00095532 4.69444 7.64256e-06H21.3056C21.7389 7.64256e-06 22.1544 0.0905261 22.5521 0.271563C22.9498 0.4526 23.2806 0.711156 23.5444 1.04723L25.35 3.25001C25.5667 3.51482 25.7294 3.80371 25.8382 4.11667C25.947 4.42964 26.001 4.75464 26 5.09167V23.1111C26 23.9056 25.7174 24.5859 25.1521 25.1521C24.5868 25.7183 23.9065 26.001 23.1111 26H2.88889ZM3.46667 4.33334H22.5333L21.3056 2.8889H4.69444L3.46667 4.33334ZM18.7778 7.22223H7.22222V18.7778L13 15.8889L18.7778 18.7778V7.22223Z"
        fill="#FFB300"
      />
    </svg>
  );
}
